import { observer } from 'mobx-react-lite'
import React from 'react'
import { ParticipantsViewModel } from './edit-participants/participantsViewModel'
import { EditParticipantsDialog } from './edit-participants/editParticipantsDialog'
import PropTypes from 'prop-types'
import Translator from '../translator'
import clx from 'classnames'
import Settings from '../settings'
import { RootStore } from '../../datastores/rootStore'

export const CartItemEditParticipantsButton = observer(
  function CartItemEditParticipantsButton(props) {
    const [isOpen, setIsOpen] = React.useState(false)
    let cart = RootStore.getInstance().cart

    let participants = cart.eventGroupsStore.get(props.eventGroup.id).participants
    const [p] = React.useState(new ParticipantsViewModel(participants))
    return (
      <React.Fragment>
        {props.eventGroup.participants.length > 0 ? (
          <div className='mtt-cart-product__participants'>
            <img
              src={Settings.getSetting('icons/participants.svg', 'cart')}
              alt=''
              width={'19.98'}
              height={'13.98'}
            />
            {Translator.translateNumber('%s deltager', '%s deltagere', props.eventGroup.participants.length, 'participant')}
          </div>
        ) : null}
        <div
          className={clx({
            button: true,
            blue: props.eventGroup.participants.length > 0,
            orange: props.eventGroup.participants.length <= 0,
            smaller: true
          })}
          onClick={() => {
            if (!p.isDirty) {
              p.reset()
            }
            setIsOpen(true)
          }}
        >
          {props.eventGroup.participants.length <= 0 ? (
            <img
              src={Settings.getSetting('icons/participants-white.svg', 'cart')}
              alt=''
              width={'19.98'}
              height={'13.98'}
            />
          ) : null}
          {props.eventGroup.participants.length > 0
            ? Translator.translate('Ret', 'participant')
            : Translator.translate('Tilføj deltagere', 'participant')}
        </div>

        <EditParticipantsDialog
          eventGroup={props.eventGroup}
          open={isOpen}
          onClose={() => {
            p.reset()
            setIsOpen(false)
          }}
          p={p}
        />
      </React.Fragment>
    )
  }
)
CartItemEditParticipantsButton.propTypes = {
  eventGroup: PropTypes.object.isRequired
}
